import * as React from 'react';

import type { PlainUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';

interface OwnProps {
	originalUnit: PlainUnitEnum;
}

type Props = OwnProps;

const OriginalUnitPrice: React.FC<Props> = (props) => {
	const { originalUnit } = props;

	return (
		<div>
			<div><b>Price per {originalUnit}</b></div>
			<div>
				Unit price the material was originally declared in.
			</div>
			<br />
			<div>This value is shown for reference.</div>
		</div>
	);
};

export default React.memo(OriginalUnitPrice);
